class Search {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.findElements();
    this.initUiState();
    this.attachEvents();
  }

  findElements() {
    this.label = this.rootElement.querySelector('[data-entity="label"]');
  }

  initUiState() {
    this.uiState = {
      labelVisibility: 'shown',
    };
  }

  attachEvents() {
    this.rootElement.addEventListener('submit', (event) => event.preventDefault());

    this.rootElement.addEventListener('focusin', this.inputFocusHandler.bind(this));

    this.rootElement.addEventListener('focusout', this.inputBlurHandler.bind(this));
  }

  inputFocusHandler(event) {
    if (!event.target.closest('[data-entity="input"]')) return;

    this.uiState.labelVisibility = 'hidden';

    this.renderLabel();
  }

  inputBlurHandler(event) {
    if (!event.target.closest('[data-entity="input"]')) return;

    const inputValue = event.target.value;
    this.uiState.labelVisibility = inputValue !== '' ? 'hidden' : 'shown';

    this.renderLabel();
  }

  renderLabel() {
    if (this.uiState.labelVisibility === 'hidden') {
      this.label.classList.add('search__label_hidden');
    }

    if (this.uiState.labelVisibility === 'shown') {
      this.label.classList.remove('search__label_hidden');
    }
  }
}

export default Search;
